/** Minute in seconds. */
export const MINUTE = 60
/** Hour in seconds. */
export const HOUR = MINUTE * 60
/** Day in seconds. */
export const DAY = HOUR * 24
/** Year in seconds. */
export const YEAR = DAY * 365

export const phoneNumberRegex = /^(?:(?:\+44|44|0|0044)7\d{9}|(?:0(?:1|2|3|5|8|9)\d{9,10})|(?:0044(?:1|2|3|5|8|9)\d{9,10})|(?:\+44(?:1|2|3|5|8|9)\d{9,10}))$/
export const mobileNumberRegex = /^(?:\+44|44|0|0044)7\d{9}$/

export const nameRegex = /^(?!.*['\u2019]{2})(?:[\p{L}\p{M}]+\.?)+(?:[ \-'\u2019](?:[\p{L}\p{M}]+\.?)+)*['\u2019]?$/u
